/**
 * Coldest Speed Optimizer — Phases 1-3
 * 
 * Defers non-critical third-party scripts to after first user interaction.
 * This file itself loads with defer, so it runs after DOM parse.
 * 
 * DO NOT TOUCH: Elevar, Meta Pixel, Social Snowball, Opensend, GPO, 
 * coldest-engrave-preview.js — these are loaded via content_for_header 
 * or separate script tags and are NOT managed here.
 * 
 * WHAT THIS MANAGES:
 * - Smartlook (analytics)
 */

(function() {
  'use strict';

  var loaded = false;

  function loadDeferredScripts() {
    if (loaded) return;
    loaded = true;

    // Remove the event listeners once triggered
    ['scroll', 'mousemove', 'touchstart', 'click', 'keydown'].forEach(function(evt) {
      window.removeEventListener(evt, loadDeferredScripts, { passive: true, capture: true });
    });

    // --- Smartlook ---
    try {
      window.smartlook || (function(d) {
        var o = smartlook = function() { o.api.push(arguments); };
        var h = d.getElementsByTagName('head')[0];
        var c = d.createElement('script');
        o.api = new Array();
        c.async = true;
        c.type = 'text/javascript';
        c.charset = 'utf-8';
        c.src = 'https://web-sdk.smartlook.com/recorder.js';
        h.appendChild(c);
      })(document);
      smartlook('init', '9f45bcd5a404636e5bb1aee7e3d92971b420a947', { region: 'eu' });
    } catch(e) { console.warn('Smartlook load error:', e); }

  }

  // Load on first user interaction
  ['scroll', 'mousemove', 'touchstart', 'click', 'keydown'].forEach(function(evt) {
    window.addEventListener(evt, loadDeferredScripts, { passive: true, capture: true, once: true });
  });

  // Fallback: load after 8 seconds even without interaction
  setTimeout(loadDeferredScripts, 8000);

})();
